export default {
  name: 'not-found-page'
}



// WEBPACK FOOTER //
// ./src/pages/errors/404/script.js